module.exports = __webpack_public_path__ + "img/pxpayplus.1fa21329.png";